import React, { forwardRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getMenu } from "../../assets/js/api";
import { translate } from "../../assets/js/functions";


const Menu = forwardRef(({ hidden }, ref) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    getMenu().then((items) => {
      setItems(items);
    });
  }, []);

  return (
    <nav
      ref={ref}
      aria-label="Menú principal"
      id="menu"
      className="main-nav pt-9 pb-7 px-8"
      hidden={hidden}
    >
      <ul className="is-size-5 has-text-weight-bold link-dn flow--m">
        <li><Link to="/">{translate("Inicio")}</Link></li>

        {items ? (
          items.map((item) => (
            <li key={item.section_id}>
              <Link
                to={item.web_path}
                state={{ item }}
              >
                {item.term}
              </Link>
            </li>
          ))
        ) : null}
      </ul>
    </nav>
  );
});

export default Menu;
